module.exports = __webpack_public_path__ + "static/media/5.d83fb5ab.jpg";